import { render, staticRenderFns } from "./AuthBridgeLayout.vue?vue&type=template&id=03612ec8&"
import script from "./AuthBridgeLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthBridgeLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03612ec8')) {
      api.createRecord('03612ec8', component.options)
    } else {
      api.reload('03612ec8', component.options)
    }
    module.hot.accept("./AuthBridgeLayout.vue?vue&type=template&id=03612ec8&", function () {
      api.rerender('03612ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/app/AuthBridgeLayout.vue"
export default component.exports